module.exports = __webpack_public_path__ + "img/sLightnDrg_350x350.a78a4d08.jpg";